/**
 * Created by Owner on 2016/8/9.
 */
import { Component, ElementRef, OnDestroy } from '@angular/core';
import { AlertController, ViewController, Events, ToastController, App } from 'ionic-angular';
import { LotteryPage } from "../lottery/lottery";
import { LotteryService } from "../../services/lottery.services";
import { AppConfigService } from "../../services/appConfig.service";
import { AppDialog } from "../../component/appDialog";
import { AppConfig } from "../../util/appConfig";
import * as common from '../../directives/common';
import { TaiXiuPage } from "../TaiXiu/TaiXiuPage";
import { TranslateService } from 'ng2-translate';

@Component({
    templateUrl: 'goPeriodsMMC.html',
    selector: 'go-periods-m-m-c-page',
})
export class GoPeriodsMMCPage implements OnDestroy {
    //追号总金额
    private recordList: any = [];
    private lotteryName: string;
    private goMoney: number = 0;
    private totalMoney: number = 0;
    private totalNum: number = 1;
    isGo: boolean = true;
    traceIssues: number = 1;
    goStop: boolean = true;
    public pageDome: HTMLElement;
    public dataTaiXiuWin: any;
    nono = false;
    constructor(public events: Events, private alertCtrl: AlertController, private toastCtrl: ToastController
        , private app: App, public viewCtrl: ViewController, public el: ElementRef, private translate: TranslateService) {

        this.pageDome = el.nativeElement;
        this.events.subscribe('issues:goPage', (data) => {
            // if (LotteryPage.betMoney == 0 && TaiXiuPage.betMoney === 0) {

            //     setTimeout(() => {
            //         AppDialog.toast({
            //             toastCtrl: this.toastCtrl,
            //             message: "Vui lòng thêm nội dung cược."
            //         });
            //     }, 500);                
            // }

            let lastToastTime = 0;  // Variable to track the last toast time

            if (LotteryPage.betMoney == 0 && TaiXiuPage.betMoney === 0) {
                const currentTime = new Date().getTime();

                // Check if the last toast was shown more than 1 second ago
                if (currentTime - lastToastTime > 1000) {
                    lastToastTime = currentTime;  // Update the last toast time

                    setTimeout(() => {
                        AppDialog.toast({
                            toastCtrl: this.toastCtrl,
                            message: this.translate.instant('GO_PERIODS_PAGE.ADD_BET_CONTENT')
                        });
                    }, 500);
                }
            }
            if (common.checkGameTaiXiu(data.gameID)) { // page game Tai-Xiu
                this.goMoney = TaiXiuPage.betMoney;
            } else {
                this.goMoney = LotteryPage.betMoney;
            }
            this.isGo = true;
            this.getFirstData();
            this.sendGoIssues();
        });

        this.events.subscribe('taixiu:trace', (data) => {
            this.dataTaiXiuWin = data;
        });
    }

    selectIssues(id: number) {
        this.recordList[this.traceIssues].isSelect = false;
        this.recordList[id].isSelect = true;
        this.traceIssues = id;
        this.totalNum = this.recordList[id].num;
        this.totalMoney = this.totalNum * this.goMoney;
        this.sendGoIssues();
    }

    getFirstData() {
        this.recordList = AppConfig.GoIssueListMMC;
        this.clearData();
        this.totalNum = this.recordList[0].num;
        this.totalMoney = this.totalNum * this.goMoney;
    }

    ionViewWillLeave() {
        this.clearData();
        this.isGo = false;
        this.sendGoIssues();
    }

    clearData() {
        this.recordList[this.traceIssues].isSelect = false;
        this.recordList[0].isSelect = true;
        this.traceIssues = 0;
        this.totalNum = 1;
        this.totalMoney = this.totalNum * this.goMoney;
    }

    sendGoIssues() {
        this.events.publish('issues:go', {
            isGo: this.isGo,
            totalMoney: this.totalMoney,
            totalNum: this.totalNum,
            goStop: this.goStop,
            traceIssues: this.traceIssues
        });
    }

    dismiss() {
        this.viewCtrl.getNav().parent.parent.pop();
    }

    ngOnDestroy() {
        this.events.unsubscribe('taixiu:trace');
        this.events.unsubscribe('taixiu:CloseJumpEmu');
    }
}



// WEBPACK FOOTER //
// ./src/pages/goPeriodsMMC/goPeriodsMMC.ts